import ForgotPasswordForm from "../components/global/forms/ForgotPasswordForm";
import SignUpPageLayout from "../layouts/SignUpPageLayout";

function ForgetPasswordPage() {
  return (
    <SignUpPageLayout pageTitle="Forgot Password | CSTL">
      <ForgotPasswordForm />
    </SignUpPageLayout>
  );
}

export default ForgetPasswordPage;
